export enum MfaStatus {
    PENDING = 'Pending',
    ACTIVE = 'Active',
    LOCKED = 'Locked',
}
